import { Divider, DrawerProps, Grid, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { DrawerStyled } from './InfoDrawer.styled';

export interface InfoDrawerProps extends DrawerProps {
  headline?: ReactNode;
  subHeadline?: ReactNode;
  description?: ReactNode;
}

export const InfoDrawer = ({ headline, subHeadline, description, ...otherProps }: InfoDrawerProps) => {
  return (
    <DrawerStyled anchor="right" {...otherProps}>
      <Grid>
        <Grid size={12}>
          <Typography variant="h6">{headline}</Typography>
          <Typography variant="body1" color="textSecondary" gutterBottom>
            {subHeadline}
          </Typography>
        </Grid>
        <Divider />
        {description}
      </Grid>
    </DrawerStyled>
  );
};
